import { ChangeDetectionStrategy, Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { GroupedSessions } from '@app/interfaces';
import { StreamingLeftNavigationService } from '../navigation/left-navigation.service';
import { ConversationPersistenceService } from '../conversation-persistence/conversation-persistence.service';

@Component({
    selector: 'craig-streaming-conversation-history',
    standalone: true,
    templateUrl: './streaming-conversation-history.component.html',
    styleUrls: ['./streaming-conversation-history.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StreamingConversationHistoryComponent implements OnInit, OnDestroy {
    groupedConversationSessions: GroupedSessions[] = [];
    private readonly componentDestroyed$: Subject<boolean> = new Subject();

    constructor(
        private readonly leftNavigationService: StreamingLeftNavigationService,
        private readonly conversationPersistenceService: ConversationPersistenceService,
        private readonly changeDetectorRef: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        // console.log('🔍 [StreamingConversationHistoryComponent] Initializing conversation history component');
        this.loadConversationSessions();
        this.conversationPersistenceService
            .conversationSessionsListChange()
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((isConversationSessionsListChanged: boolean) => {
                // console.log(
                //     '🔍 [StreamingConversationHistoryComponent] Conversation sessions list changed:',
                //     isConversationSessionsListChanged
                // );
                if (isConversationSessionsListChanged) {
                    this.loadConversationSessions();
                }
            });
    }

    private loadConversationSessions(): void {
        this.groupedConversationSessions = this.conversationPersistenceService.getGroupedConversationSessions();
        // console.log(
        //     '🔍 [StreamingConversationHistoryComponent] Loaded conversation sessions:',
        //     this.groupedConversationSessions
        // );
        this.changeDetectorRef.detectChanges();
    }

    ngOnDestroy(): void {
        this.componentDestroyed$.next(true);
    }

    openConversation(sessionId: number): void {
        // console.log('🔍 [StreamingConversationHistoryComponent] Opening conversation session:', sessionId);
        this.leftNavigationService.selectConversationSession(sessionId);
        // console.log('🔍 [StreamingConversationHistoryComponent] Called selectConversationSession with:', sessionId);
    }
}
